export const Stepper = ({ numberOfSteps, currentStep, children }) => {
    return (
        <div className="flex flex-col justify-center items-center p-4">
            {children}
            <div className="flex justify-center items-center space-x-2 mt-10">
                {Array.from({ length: numberOfSteps }).map((_, index) => (
                    <div key={index} className="flex flex-col items-center">
                        <div
                            className={`w-3 h-3 rounded-full ${index === currentStep ? "" : "bg-gray-300"}`}
                            style={index === currentStep
                                ? { backgroundColor: "var(--urtentic-sdk-primary, #255CFF)" }
                                : undefined}
                        ></div>
                    </div>
                ))}
            </div>
        </div>

    );
};